/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Bank } from '../model';
// @ts-ignore
import { BankSlug } from '../model';
// @ts-ignore
import { V1BankBankSlugSyncPost201Response } from '../model';
// @ts-ignore
import { V1BankBankSlugSyncPostRequest } from '../model';
/**
 * BanksApi - axios parameter creator
 * @export
 */
export const BanksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch accounts from bank api and associate with access_token. If an access token already exists and is not expired, then it will be updated with a new access token except in the case for MUFG Bank. Create related accounts and update transaction data expect for NETBK and MUFG Banks. Updates transaction data for accounts that already exists. 
         * @summary Fetch Integration Account from bank api
         * @param {BankSlug} bankSlug 
         * @param {V1BankBankSlugSyncPostRequest} v1BankBankSlugSyncPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BankBankSlugSyncPost: async (bankSlug: BankSlug, v1BankBankSlugSyncPostRequest: V1BankBankSlugSyncPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankSlug' is not null or undefined
            assertParamExists('v1BankBankSlugSyncPost', 'bankSlug', bankSlug)
            // verify required parameter 'v1BankBankSlugSyncPostRequest' is not null or undefined
            assertParamExists('v1BankBankSlugSyncPost', 'v1BankBankSlugSyncPostRequest', v1BankBankSlugSyncPostRequest)
            const localVarPath = `/v1/bank/{bank_slug}/sync`
                .replace(`{${"bank_slug"}}`, encodeURIComponent(String(bankSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1BankBankSlugSyncPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * We are providing an API that integrates the banks list from Credit with the banks list from Moneytree.\\ For Moneytree, only banks with institution_type = corporate and active = true are included in the response.\\ For non-capital entity, banks with is_public = true are included in the response. For capital entity, only banks with moneytree banks are included in the response. 
         * @summary List available Banks
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BanksAvailableGet: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('v1BanksAvailableGet', 'name', name)
            const localVarPath = `/v1/banks/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BanksApi - functional programming interface
 * @export
 */
export const BanksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BanksApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch accounts from bank api and associate with access_token. If an access token already exists and is not expired, then it will be updated with a new access token except in the case for MUFG Bank. Create related accounts and update transaction data expect for NETBK and MUFG Banks. Updates transaction data for accounts that already exists. 
         * @summary Fetch Integration Account from bank api
         * @param {BankSlug} bankSlug 
         * @param {V1BankBankSlugSyncPostRequest} v1BankBankSlugSyncPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1BankBankSlugSyncPost(bankSlug: BankSlug, v1BankBankSlugSyncPostRequest: V1BankBankSlugSyncPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1BankBankSlugSyncPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1BankBankSlugSyncPost(bankSlug, v1BankBankSlugSyncPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * We are providing an API that integrates the banks list from Credit with the banks list from Moneytree.\\ For Moneytree, only banks with institution_type = corporate and active = true are included in the response.\\ For non-capital entity, banks with is_public = true are included in the response. For capital entity, only banks with moneytree banks are included in the response. 
         * @summary List available Banks
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1BanksAvailableGet(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Bank>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1BanksAvailableGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BanksApi - factory interface
 * @export
 */
export const BanksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BanksApiFp(configuration)
    return {
        /**
         * Fetch accounts from bank api and associate with access_token. If an access token already exists and is not expired, then it will be updated with a new access token except in the case for MUFG Bank. Create related accounts and update transaction data expect for NETBK and MUFG Banks. Updates transaction data for accounts that already exists. 
         * @summary Fetch Integration Account from bank api
         * @param {BanksApiV1BankBankSlugSyncPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BankBankSlugSyncPost(requestParameters: BanksApiV1BankBankSlugSyncPostRequest, options?: AxiosRequestConfig): AxiosPromise<V1BankBankSlugSyncPost201Response> {
            return localVarFp.v1BankBankSlugSyncPost(requestParameters.bankSlug, requestParameters.v1BankBankSlugSyncPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * We are providing an API that integrates the banks list from Credit with the banks list from Moneytree.\\ For Moneytree, only banks with institution_type = corporate and active = true are included in the response.\\ For non-capital entity, banks with is_public = true are included in the response. For capital entity, only banks with moneytree banks are included in the response. 
         * @summary List available Banks
         * @param {BanksApiV1BanksAvailableGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BanksAvailableGet(requestParameters: BanksApiV1BanksAvailableGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<Bank>> {
            return localVarFp.v1BanksAvailableGet(requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v1BankBankSlugSyncPost operation in BanksApi.
 * @export
 * @interface BanksApiV1BankBankSlugSyncPostRequest
 */
export interface BanksApiV1BankBankSlugSyncPostRequest {
    /**
     * 
     * @type {BankSlug}
     * @memberof BanksApiV1BankBankSlugSyncPost
     */
    readonly bankSlug: BankSlug

    /**
     * 
     * @type {V1BankBankSlugSyncPostRequest}
     * @memberof BanksApiV1BankBankSlugSyncPost
     */
    readonly v1BankBankSlugSyncPostRequest: V1BankBankSlugSyncPostRequest
}

/**
 * Request parameters for v1BanksAvailableGet operation in BanksApi.
 * @export
 * @interface BanksApiV1BanksAvailableGetRequest
 */
export interface BanksApiV1BanksAvailableGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BanksApiV1BanksAvailableGet
     */
    readonly name: string
}

/**
 * BanksApi - object-oriented interface
 * @export
 * @class BanksApi
 * @extends {BaseAPI}
 */
export class BanksApi extends BaseAPI {
    /**
     * Fetch accounts from bank api and associate with access_token. If an access token already exists and is not expired, then it will be updated with a new access token except in the case for MUFG Bank. Create related accounts and update transaction data expect for NETBK and MUFG Banks. Updates transaction data for accounts that already exists. 
     * @summary Fetch Integration Account from bank api
     * @param {BanksApiV1BankBankSlugSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BanksApi
     */
    public v1BankBankSlugSyncPost(requestParameters: BanksApiV1BankBankSlugSyncPostRequest, options?: AxiosRequestConfig) {
        return BanksApiFp(this.configuration).v1BankBankSlugSyncPost(requestParameters.bankSlug, requestParameters.v1BankBankSlugSyncPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * We are providing an API that integrates the banks list from Credit with the banks list from Moneytree.\\ For Moneytree, only banks with institution_type = corporate and active = true are included in the response.\\ For non-capital entity, banks with is_public = true are included in the response. For capital entity, only banks with moneytree banks are included in the response. 
     * @summary List available Banks
     * @param {BanksApiV1BanksAvailableGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BanksApi
     */
    public v1BanksAvailableGet(requestParameters: BanksApiV1BanksAvailableGetRequest, options?: AxiosRequestConfig) {
        return BanksApiFp(this.configuration).v1BanksAvailableGet(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}
